export default function getUberToken(state) {
    const { uberToken } = state;

    if (!uberToken && state.auth) {
        // TODO Align apps auth storage.
        return state.auth.uberToken;
    }

    return uberToken;
}
